import { PropsWithChildren } from 'react';
import styles from './help-button.module.css';
import { Icon } from '../symbols';
import { ClassName, cn } from '../../utils';
import { Popover, PopoverContent, PopoverTrigger } from '../popover';
import { useTranslation } from 'react-i18next';

type HelpButtonProps = PropsWithChildren<{
  variant?: 'help' | 'info';
  size?: 'small';
  className?: ClassName;
}>;

export function HelpButton({
  children,
  variant = 'help',
  size,
  className,
}: HelpButtonProps) {
  const { t } = useTranslation('kyc');
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          aria-haspopup="dialog"
          aria-label={t('SHOW_HELP_TEXT')}
          className={cn(
            styles.button,
            styles[variant],
            styles[`size-${size}`],
            className,
          )}
          type="button"
        >
          <Icon name={`${variant}-circle`} />
        </button>
      </PopoverTrigger>

      <PopoverContent
        className={styles.popover}
        showArrow
        arrowClassName={styles.arrow}
        sideOffset={5}
        alignOffset={-10}
        align="end"
      >
        {children}
      </PopoverContent>
    </Popover>
  );
}
